import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { StatisticsAvailabilityResponse } from '../../models/statistics-availability.model';
import { StatisticsQueryRequest, StatisticsQueryResponse } from '../../models/statistics-query.model';
import { ProjectStructureResponse } from '../../models/project-structure.model';
import { ProjectStructureEntitiesResponse } from '../../models/project-structure-entities.model';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private readonly baseUrl = environment.baseUrl || 'http://127.0.0.1:8080';

  constructor(private http: HttpClient) { }

  getStatisticsAvailability(projectId: string, timezone: string = 'Europe/Madrid'): Observable<StatisticsAvailabilityResponse> {
    const query = new URLSearchParams({
      project_id: projectId,
      timezone
    });

    return this.http.get<StatisticsAvailabilityResponse>(
      `${this.baseUrl}/statistics/availability?${query.toString()}`
    );
  }

  getStatistics(request: StatisticsQueryRequest): Observable<StatisticsQueryResponse> {
    const query = new URLSearchParams({
      project_id: request.project_id,
      content_id: request.content_id,
      source_content_type: request.source_content_type,
      target_content_type: request.target_content_type,
      aggregation_level: request.aggregation_level,
      metric_type: request.metric_type,
      metric_subtype: request.metric_subtype,
      startDate: request.startDate,
      endDate: request.endDate,
      granularity: request.granularity
    });

    if (request.language) {
      query.set('language', request.language);
    }

    return this.http.get<StatisticsQueryResponse>(
      `${this.baseUrl}/statistics?${query.toString()}`
    );
  }

  getProjectStructure(projectId: string): Observable<ProjectStructureResponse> {
    return this.http.get<ProjectStructureResponse>(
      `${this.baseUrl}/projects/${encodeURIComponent(projectId)}/structure`
    );
  }

  getProjectStructureEntities(params: {
    projectId: string;
    contentTypeId?: string | null;
    language?: string | null;
  }): Observable<ProjectStructureEntitiesResponse> {
    const query = new URLSearchParams();
    if (params.language) {
      query.set('language', params.language);
    }
    if (params.contentTypeId) {
      query.set('contentTypeId', params.contentTypeId);
    }

    const suffix = query.toString().length > 0 ? `?${query.toString()}` : '';
    return this.http.get<ProjectStructureEntitiesResponse>(
      `${this.baseUrl}/projects/${encodeURIComponent(params.projectId)}/structure/entities${suffix}`
    );
  }
}
